import HeroPublisherView from "../componentView/HeroPublisherView";
import { ListRendererFn } from "./ListRenderer";
import React from "react";
import styles from "../styles.module.scss";
const HeroPublisherRenderer: ListRendererFn = ({ onFocus, leaveFor, list, page }) => {
  return (
    <HeroPublisherView
      list={list}
      key={list.uuid}
      leaveFor={leaveFor}
      onFocus={onFocus}
      page={page}
      className={styles.heroPublisher}
    />
  );
};
export default HeroPublisherRenderer;
